import Box from 'components/shared/Box'
import Link from 'components/shared/Link'
import { ReservationRowProps } from 'components/shared/Reservation/types'
import SeparatedList from 'components/shared/SeparatedList'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { SpaReservation } from 'store/selfcare-slice/types'
import { useApp } from 'store/steps'
import SpaItem from './SpaItem'
import TicketRow from './TicketRow'

interface SpaRowProps extends ReservationRowProps {
    spa: SpaReservation[] | null
}

const SpaRow = ({ mode, handleEdit, spa }: SpaRowProps) => {
    const { stepId } = useApp()
    const isSummary = stepId === 'summary'

    return (
        <Box isFullWidth>
            <Box
                direction="row"
                align="center"
                justify="space-between"
                isFullWidth
                mb={[16, 24]}
            >
                <Text variant="heading3" color="secondary_700">
                    <FormattedMessage
                        id="order.thankyou.relaxtation_title_subheading"
                        defaultMessage="Wellness & SPA"
                    />
                </Text>
                {mode === 'summary' && handleEdit && (
                    <Link
                        variant="gray"
                        icon={null}
                        onClick={() => handleEdit('manage-spa')}
                        data-testid="selfcare-summary-button-edit-spa"
                    >
                        <FormattedMessage
                            id="selfcare.edit"
                            defaultMessage="Edytuj"
                        />
                    </Link>
                )}
            </Box>
            <Box isFullWidth>
                <SeparatedList
                    direction="column"
                    gap={[16, 24]}
                    isFullWidth
                    borderWidth={2}
                    borderColor="grayscale_300"
                    hasLastItemBorder
                >
                    {spa?.map((spa) => {
                        const { changes, original, changeType } = spa

                        const dataToDisplay =
                            isSummary && changes ? changes : original
                        const { price, detail } = dataToDisplay || {}
                        const { orderSpaTreatmentId } = detail || {}

                        const spaPrice = price || 0
                        const isReturned = isSummary && changeType === 'return'

                        return (
                            <TicketRow
                                price={spaPrice}
                                key={orderSpaTreatmentId}
                                isReturned={isReturned}
                            >
                                <SpaItem spa={spa} isDisabled={isReturned} />
                            </TicketRow>
                        )
                    })}
                </SeparatedList>
            </Box>
        </Box>
    )
}

export default SpaRow
